<template>
    <div>
        <Head :title="`${order.liqPayId}`"/>
        <h1 class="mb-8 text-3xl font-bold">
            <Link
                class="text-indigo-400 hover:text-indigo-600"
                :href="$route('table.reports')"
            >
                Всі замовлення
            </Link>
            <span class="text-indigo-400 font-medium">/</span>
            Замовлення номер {{ order.liqPayId }}
        </h1>
        <div v-if="order.log" class="p-4 bg-white mb-2 max-w-3xl">
            <p>{{ order.log }}</p>
        </div>
        <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
            <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                <text-input v-model="form.name" class="pb-8 pr-6 w-full lg:w-1/2"
                            label="Ім'я"/>
                <text-input v-model="form.phone" class="pb-8 pr-6 w-full lg:w-1/2"
                            label="Телефон"/>
                <select-input
                    v-model="form.items[0].lakeId"
                    class="pb-8 pr-6 w-full lg:w-1/2"
                    label="Озеро"
                >
                    <option
                        v-for="lake in lakes"
                        :key="lake.id"
                        :value="lake.id"
                    >
                        {{ lake.name }}
                    </option>
                </select-input>
                <select-input
                    v-if="order.is_point"
                    v-model="form.items[0].pointId"
                    class="pb-8 pr-6 w-full lg:w-1/2"
                    label="Місце рибалки"
                >
                    <option
                        v-for="point in points"
                        :key="point.id"
                        :value="point.id"
                    >
                        {{ point.name }}
                    </option>
                </select-input>
                <text-input
                    v-else
                    class="pb-8 pr-6 w-full lg:w-1/2"
                    label="Швидке замовлення"
                    :model-value="order.fastOrder?.name ?? '—'"
                    disabled
                />
                <select-input
                    v-model="form.items[0].typeId"
                    class="pb-8 pr-6 w-full lg:w-1/2"
                    label="Тип рибалки"
                >
                    <option
                        v-for="type in types"
                        :key="type.id"
                        :value="type.id"
                    >
                        {{ type.name }}
                    </option>
                </select-input>
                <select-input
                    v-model="form.items[0].categoryId"
                    class="pb-8 pr-6 w-full lg:w-1/2"
                    label="Тариф рибалки"
                >
                    <option
                        v-for="category in categories"
                        :key="category.id"
                        :value="category.id"
                    >
                        {{ category.name }}
                    </option>
                </select-input>
                <text-input
                    class="pb-8 pr-6 w-full lg:w-1/2"
                    label="Дата"
                    v-model="form.items[0].start_date"
                />
                <text-input
                    v-model="form.items[0].totalSum"
                    class="pb-8 pr-6 w-full lg:w-1/2"
                    label="Сумма замовлення, грн"
                />
                <text-input
                    v-model="form.items[0].quantity"
                    class="pb-8 pr-6 w-full lg:w-1/2"
                    label="Кількість людей"
                />
                <select-input
                    v-model="form.items[0].attributesIds"
                    class="pb-8 pr-6 w-full lg:w-1/2"
                    label="Атрибути"
                    multiple
                >
                    <option
                        v-for="attribute in form.items[0].attributes"
                        :key="attribute.id"
                        :value="attribute.id"
                    >
                        {{ attribute.title }}
                    </option>
                </select-input>
                <checkbox
                    v-model="order.is_payed"
                    class="w-full lg:w-1/2"
                    label="Оплачено"
                    @update:modelValue="value => payOrder(value, order)"
                />
                <checkbox
                    class="w-full lg:w-1/2"
                    :model-value="order.is_done"
                    label="Виконано"
                    @update:modelValue="value => approveOrder(value, order)"
                />
                <checkbox
                    class="w-full lg:w-1/2"
                    :model-value="order.is_cancel"
                    label="Скасовано"
                    @update:modelValue="value => canceled(value, order)"
                />
            </div>
            <div class="flex items-center justify-between px-8 py-4 bg-gray-50 border-t border-gray-100">
                <button class="text-red-600 hover:underline" tabindex="-1" type="button"
                        @click.prevent="destroy">
                    Видалити
                </button>
                <div class="flex">
                    <loading-button class="btn-indigo mr-4" @click.prevent="update">
                        Оновити
                    </loading-button>
                    <a :href="$route('invoice.download', encodeBase64(order.liqPayId))"
                       class="hover:underline flex items-center"
                       tabindex="-1"
                       type="button"
                    >
                        Скачати чек
                        <icon role="button" name="downloadPdf" class="block w-6 h-6 fill-gray-400"/>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import Checkbox from '@/Shared/Checkbox'
import Icon from "@/Shared/Icon"
import axios from "axios";
import SelectInput from "@/Shared/SelectInput.vue";
import LoadingButton from "@/Shared/LoadingButton.vue";

export default {
    components: {
        LoadingButton,
        SelectInput,
        Icon,
        Checkbox,
        Head,
        Link,
        TextInput,
    },
    layout: Layout,
    props: {
        order: Object,
    },
    data() {
        return {
            form: this.$inertia.form({
                name: this.order.name,
                phone: this.order.phone,
                items: [{
                    id: this.order.id,
                    lakeId: this.order.lake.id,
                    pointId: this.order.point?.id ?? null,
                    fast_order_id: this.order.fastOrder?.id ?? null,
                    typeId: this.order.type?.id ?? null,
                    categoryId: this.order.category?.id ?? null,
                    start_date: this.order.start_date,
                    totalSum: this.order.totalSum,
                    quantity: this.order.quantity,
                    is_cancel: this.order.is_cancel,
                    attributes: this.order.attributes,
                    attributesIds: this.order.attributes.map(attribute => {
                        return attribute.id
                    })
                }]
            }),
            types: [],
            categories: [],
            lakes: [],
            points: [],
        }
    },
    methods: {
        encodeBase64(id) {
            return Buffer.from(id.toString()).toString('base64')
        },
        async fetchData() {
            await Promise.all([
                this.fetchTypes(),
                this.fetchCategories(),
                this.fetchLakes(),
            ])
        },
        async fetchTypes() {
            const response = await axios.get(this.$route('all.types'))
            this.types = await response.data.types;
        },
        async fetchCategories() {
            const response = await axios.get(this.$route('all.categories'))
            this.categories = await response.data.categories;
        },
        async fetchLakes() {
            const response = await axios.get(this.$route('all.lakes'))
            this.lakes = await response.data.lakes;
            await this.fetchPoints()
        },
        async fetchPoints() {
            this.points = []
            if (this.form.items[0].lakeId) {
                const response = await axios.get(this.$route('all.points', this.form.items[0].lakeId))
                this.points = await response.data.points;
            }
        },
        destroy() {
            this.$inertia.delete(this.$route('order.destroy', this.order.id))
        },
        download() {
            this.$inertia.get(this.$route('invoice.download', this.encodeBase64(this.order.liqPayId)))
        },
        approveOrder(value, order) {
            this.$inertia.post(
                this.$route('order.approve', order.id),
                {
                    is_done: value
                },
                {
                    preserveState: true,
                    preserveScroll: true
                }
            );
        },
        payOrder(value, order) {
            this.$inertia.post(this.$route('order.pay', order.id),
                {
                    is_payed: value
                },
                {
                    preserveState: true,
                    preserveScroll: true
                }
            );
        },
        update() {
            this.form.post(this.$route('order.update', this.order.id))
        },
        canceled(value, order) {
            this.$inertia.post(this.$route('order.cancel', order.id),
                {
                    is_cancel: value
                },
                {
                    preserveState: true,
                    preserveScroll: true
                }
            );
        }
    },
    created() {
        this.fetchData()
    }
}
</script>
